import React from 'react';
import { Dialog, Card, CardContent, Typography, Button } from '@mui/material';

interface NotificationModalProps {
  className?: string;
  isOpen: boolean;
  onClose: () => void;
  message: any;
  buttonText: string;
  onConfirm?: () => void;
  secondaryButtonText?: string;
  onSecondaryButtonClick?: () => void;
  disableBackdropClick?: boolean;
}

const NotificationModal: React.FC<NotificationModalProps> = ({
  className,
  isOpen,
  onClose,
  message,
  buttonText,
  onConfirm,
  secondaryButtonText,
  onSecondaryButtonClick,
  disableBackdropClick,
}) => {
  return (
    <Dialog
      open={isOpen}
      onClose={disableBackdropClick ? undefined : onClose}
      className={className}
      aria-describedby="notification-dialog-description"
    >
      <Card sx={{ padding: 2, textAlign: 'center', maxWidth: 400, minWidth: 300, margin: 'auto' }}>
        <CardContent>
          <Typography id="notification-dialog-description" variant="body1" sx={{ marginBottom: 2 }}>
            {
              typeof message === 'string' ? (
                <span>{message}</span>): (
                  <div>
                    <span>{message.message}</span>
                    <a href={message.href}>{message.linkText}</a>
                  </div>
                )
            }
          </Typography>
          <Button
            aria-label={buttonText}
            variant="contained"
            color="primary"
            onClick={onConfirm || onClose}
          >
            {buttonText}
          </Button>
          {secondaryButtonText && onSecondaryButtonClick && (
            <Button
              aria-label={secondaryButtonText}
              variant="outlined"
              color="secondary"
              onClick={onSecondaryButtonClick}
              sx={{ marginLeft: 2 }}
            >
              {secondaryButtonText}
            </Button>
          )}
        </CardContent>
      </Card>
    </Dialog>
  );
};

NotificationModal.defaultProps = {
  className: '',
  onConfirm: undefined,
  secondaryButtonText: '',
  onSecondaryButtonClick: undefined,
  disableBackdropClick: false,
};

export default NotificationModal;